import { get, post } from 'services/api';
import { WebhookParamProps } from 'modules/systemWebhooks/types';

const base = `/settings/webhooks`;

export const SYSTEM_WEBHOOKS_URL = '/integrations/webhooks.json';
export const CREATE_SYSTEM_WEBHOOK = `${base}/create`;
export const DELETE_SYSTEM_WEBHOOK = `${base}/delete`;
export const VALIDATE_SYSTEM_WEBHOOK = `${base}/validate`;
export const UPDATE_SYSTEM_WEBHOOK = `${base}/update`;

/**
 * gets a JSON list of system webhooks
 * @return { Object[] } Object containing a list of system webhooks
 */
export const fetchSystemWebhooks = () => get(SYSTEM_WEBHOOKS_URL);

/**
 * makes a post call to create a system webhook
 * @return { Object[] } Object containing created system webhook
 */
export const createSystemWebhook = (params: WebhookParamProps) =>
  post(CREATE_SYSTEM_WEBHOOK, params);

/**
 * makes a post call to delete an existing system webhook
 * @return { Object[] } Object containing delete confirmation message
 */
export const deleteSystemWebhook = (id: number) => post(DELETE_SYSTEM_WEBHOOK, { webhookId: id });

/**
 * Validate a URL including merge parameters
 */
type ValidateResponse = {
  status: string;
  message: string[];
};
export const validateSystemWebhook = (url: string): Promise<ValidateResponse> =>
  post(VALIDATE_SYSTEM_WEBHOOK, url);

/**
 * makes a post call to update an existing system webhook
 * @return { Object[] } Object containing details of updated webhook
 */
export const updateSystemWebhook = (params: WebhookParamProps) =>
  post(UPDATE_SYSTEM_WEBHOOK, params);
